export default "__VITE_ASSET__CVNhuWLg__"